import { createPortal } from "react-dom";
import { useAppDrawer } from "../store/app-drawer";
import CanvasMediaDrawer from "./CanvasMediaDrawer";
import { Stack } from "@mui/material";
import { useCropperStore } from "../store/cropper/cropper-store";
import TextTruncate from "./TextTruncate";
import l10n from "../lib/l10n";
import { useRef } from "react";

function CanvasMediaBundler_Impl() {
  const { invokeDrawer } = useAppDrawer();
  const preset = useCropperStore(s => s.preset);
  const onClick = () => invokeDrawer(<CanvasMediaDrawer />);
  return (
    <Stack className="wppr-media-selector" onClick={onClick}>
      <div className="wppr-media-selector__item-name">
        <Stack className="wppr-media-selector__item-label">
          <TextTruncate>{preset.media}</TextTruncate>
        </Stack>
        <button className="wppr-media-selector__item-select-others btn button wp-element-button">
          <span>⇄</span>
          Scegli il materiale
        </button>
      </div>
    </Stack>
  );
}

function CanvasMediaBundler() {
  const rootRef = useRef( document.querySelector( l10n.wppr_media_frontend_root ) );
  
  if (l10n.wppr_cjs_ctrl_materials_active !== "yes"
  || !rootRef.current) {
    return null;
  }

  return createPortal(
    <CanvasMediaBundler_Impl />,
    rootRef.current
  );
}

export default CanvasMediaBundler;